var _ = require('underscore');
module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='<li class="comment '+
((__t=( classes ))==null?'':__t)+
'" id="comment-'+
((__t=( id ))==null?'':__t)+
'"> <div id="div-comment-'+
((__t=( id ))==null?'':__t)+
'" class="comment-body"> <div class="comment-author vcard"> <cite class="fn">'+
((__t=( author ))==null?'':__t)+
'</cite> </div> <div class="comment-meta commentmetadata"> <a href="#comment-'+
((__t=( id ))==null?'':__t)+
'">'+
((__t=( timestamp ))==null?'':__t)+
'</a>&nbsp;&nbsp; </div> <p>'+
((__t=( message ))==null?'':__t)+
'</p> ';
 if (replyTo == 0)
		{
			print('<div class="reply"><a rel="nofollow" class="comment-reply-link" href="?replytocom=' + replyTo + '#respond">' + replyToLabel + '</a></div>');
		}
		
__p+=' </div> </li>';
}
return __p;
};
